import { HiDocumentReport } from 'react-icons/hi';
import { TbReportAnalytics } from 'react-icons/tb';
import { TbReport } from 'react-icons/tb';
import { RiDeleteBin4Fill } from 'react-icons/ri';
import { TbFileReport } from 'react-icons/tb';
import { MdReceiptLong } from 'react-icons/md';

const tiles = [
  {
    sNo: 1,
    link: '/common/production/pressShop',
    isLink: true,
    icon: <HiDocumentReport size="5rem" color="#a12222" />,
    p: 'PRESS',
    span: 'SHOP',
    isIcon: true,
  },
  {
    sNo: 2,
    link: '/common/breakDownSlipList',
    isLink: true,
    icon: <MdReceiptLong size="5rem" color="#a12222" />,
    p: 'BREAK DOWN',
    span: 'SLIP',
    isIcon: true,
  },
  // {
  //   sNo: 2,
  //   link: '/admin/pressShop',
  //   isLink: true,
  //   icon: <TbReportAnalytics size="5rem" color="#a12222" />,
  //   p: 'Press',
  //   span: 'Shop',
  //   isIcon: true,
  // },
  // {
  //   sNo: 3,
  //   link: '/admin/pdc',
  //   isLink: true,
  //   icon: <TbReport size="5rem" color="#a12222" />,
  //   p: 'PDC',
  //   span: 'Section',
  //   isIcon: true,
  // },
  // {
  //   sNo: 4,
  //   link: '/admin/CNCSection',
  //   isLink: true,
  //   icon: <TbFileReport size="5rem" color="#a12222" />,
  //   p: 'CNC',
  //   span: 'Section',
  //   isIcon: true,
  // },
];

export default tiles;
